






import { Vue, Component, Prop } from "vue-property-decorator";
import { Activity } from "@/graphql/query/activity/feed";
import { GroupLink } from "./helper";

@Component({ components: { GroupLink } })
export default class CreateGroupLog extends Vue {
  @Prop({ type: Object, required: true }) activity!: Activity;
}
